export type THqStoragePaywallFlow = {
    onBeforeCheckout?: (signal: AbortSignal) => Promise<boolean>
}

let openFlow: THqStoragePaywallFlow | null = null

/**
 * Callbacks cannot live in the store, and the opener may unmount (a soft Back) while the global
 * dialog stays up, so they are held here until `HqStoragePaywallFlowRunner` sees the flow end.
 */
export const startHqStoragePaywallFlow = (flow: THqStoragePaywallFlow) => {
    openFlow = flow
}

export const getHqStoragePaywallFlow = (): THqStoragePaywallFlow | null => openFlow

export const endHqStoragePaywallFlow = (): THqStoragePaywallFlow | null => {
    const flow = openFlow

    openFlow = null

    return flow
}
